import * as React from 'react';
import * as classNames from "classnames";

export interface IAlertProps {
    className?: string;
    icon?: string;
    title: string;
    type?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning'| 'info' | 'light' | 'dark';
}

class Alert extends React.Component<IAlertProps, any> {
    constructor(props, context) {
        super(props, context);
    }


    render() {
        const { className, icon, title, type } = this.props;

        const classType = type ? `alert-${type}` : undefined;

        return (
            <p className={classNames(className, classType, "alert p-0")}>
                <i className={classNames(icon, "fa p-3")} />{title}
            </p>
        );
    }
}

export default Alert;
